import { render } from "./WebsiteFormMenu.vue?vue&type=template&id=391c6d81"
import script from "./WebsiteFormMenu.vue?vue&type=script&lang=js"
export * from "./WebsiteFormMenu.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/mixitweb-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__